import { Leaf } from "lucide-react";
import { CERTIFICATIONS } from "@/data/catalog";
import { useLang } from "@/i18n/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="footer" className="bg-[#1A2118] text-[#F4F1EB]/70">
      <div className="mx-auto max-w-[1400px] border-t border-[#F4F1EB]/10 px-6 py-12 md:px-10">
        <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
          <div className="flex items-center gap-2.5">
            <Leaf strokeWidth={1.5} className="h-6 w-6 text-[#B85D43]" />
            <span className="font-serif-display text-xl font-medium text-[#F4F1EB]">
              Herblabs Private Limited
            </span>
          </div>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {CERTIFICATIONS.map((c) => (
              <span key={c.code} className="overline text-[#D4A373]">
                {c.code}
              </span>
            ))}
          </div>
        </div>
        <div className="mt-10 flex flex-col justify-between gap-3 border-t border-[#F4F1EB]/10 pt-6 text-xs md:flex-row">
          <span>© {year} {t("footer.rights")}</span>
          <span className="font-serif-display italic text-[#F4F1EB]/50">
            {t("footer.tagline")}
          </span>
        </div>
      </div>
    </footer>
  );
}
